import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";

@Component({
	selector: "page-inventorypending",
	templateUrl: "inventorypending.html"
})
export class InventoryPendingPage {
	constructor(public navCtrl: NavController, public navParams: NavParams) {}

	ionViewDidLoad() {}
}



// WEBPACK FOOTER //
// ./src/pages/inventory/inventorypending/inventorypending.ts